var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "menu" }, [
    _c("p", { staticClass: "menu-label" }, [_vm._v("Settings")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "MeetingSettings" } } }, [
            _vm._v("\n        General Settings\n      ")
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "menu-label" }, [_vm._v("Schedule")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "MeetingDashboard",
                  params: { id: _vm.meeting.id }
                },
                exact: ""
              }
            },
            [_vm._v("Appointment Times")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "menu-label" }, [_vm._v("Contacts")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "ManageRetailers" } } }, [
            _vm._v("Manage Retailers")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "ManageSuppliers" } } }, [
            _vm._v("Manage Suppliers")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { attrs: { to: { name: "ManageServiceProviders" } } },
            [_vm._v("Manage Service Providers")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "menu-label" }, [_vm._v("Export")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c("li", [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.runUsersExport($event)
              }
            }
          },
          [
            _vm._v(
              "\n        Retailers, Suppliers, and Service Providers\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.runScheduleExport($event)
              }
            }
          },
          [_vm._v("Schedules")]
        )
      ]),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { attrs: { to: { name: "SummaryReportBuilder" } } },
            [_vm._v("Summary Report")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "menu-label" }, [_vm._v("Reports")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "ViewFullSchedule" } } }, [
            _vm._v("View Full Schedule")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "PrintableSchedules" } } }, [
            _vm._v("Printable Schedules")
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "menu-label" }, [_vm._v("Status")]),
    _vm._v(" "),
    _c("ul", { staticClass: "menu-list" }, [
      _c("li", [
        _vm.currentPhase.advanceText
          ? _c(
              "button",
              {
                staticClass: "button block is-small flex mt-2",
                on: {
                  click: function($event) {
                    return _vm.advancePhase()
                  }
                }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.currentPhase.advanceText))])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "button",
          {
            staticClass: "button block is-small flex",
            on: {
              click: function($event) {
                return _vm.toggleArchived()
              }
            }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.meeting.is_archived ? "Unarchive" : "Archive"))
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-cog" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-folder-open" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43921134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43921134","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/meeting/MeetingMenu.vue
// module id = null
// module chunks = 